import { render } from '@verndale/core';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';
import globModules from './glob-modules';
import Modal from './modules/modal';
import Input from './modules/input';

const instantiateModule = (elements, Module) =>
  render(elements, el => new Module(el));

const modules = [];

export function global() {
  const $modals = document._$$('.modal');
  const $inputFields = document.querySelectorAll('.field__input');

  instantiateModule($modals, Modal);
  instantiateModule($inputFields, Input);
  defineCustomElements(window);
}

export default [...globModules, ...modules];
